import { render } from "./AdminViewPR.vue?vue&type=template&id=0d0db952"
import script from "./AdminViewPR.vue?vue&type=script&lang=js"
export * from "./AdminViewPR.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__